import { useWatch, UseFormMethods, UnpackNestedValue } from 'react-hook-form'
import { CreateLoadSchemaType, IShipmentMotorCarrier } from 'apps/fleet-planner/schema'
import { IShipment } from 'apps/fleet-planner/types/CreateLoadSchema'

interface IUseWatchLoadProps extends Pick<UseFormMethods<CreateLoadSchemaType>, 'control'> {
  /**
   * Allows passing default values, if necessary
   */
  defaultValues?: Pick<
    UnpackNestedValue<CreateLoadSchemaType>,
    'stops' | 'externalId' | 'drivers' | 'motorCarrier'
  >
}

/**
 * Helper to access form values while using CreateLoadFormContext.
 */
export const useWatchLoad = ({ control, defaultValues }: IUseWatchLoadProps) => {
  const {
    stops: defaultStops = [],
    externalId: defaultExternalId = '',
    drivers: defaultDrivers = [],
    motorCarrier: defaultMotorCarrier = {},
  } = defaultValues || {}

  const stops = useWatch<IShipment['stops']>({
    name: 'stops',
    control,
    defaultValue: defaultStops,
  })

  const externalId = useWatch<IShipment['externalId']>({
    name: 'externalId',
    control,
    defaultValue: defaultExternalId,
  })

  const drivers = useWatch<IShipment['drivers']>({
    name: 'drivers',
    control,
    defaultValue: defaultDrivers,
  })

  const motorCarrier = useWatch<IShipment['motorCarrier']>({
    name: 'motorCarrier',
    control,
    defaultValue: defaultMotorCarrier as IShipmentMotorCarrier,
  })

  const dispatcherId = useWatch<IShipment['dispatcherId']>({
    name: 'dispatcherId',
    control,
    defaultValue: 0,
  })

  return {
    stops,
    externalId,
    drivers,
    motorCarrier,
    dispatcherId,
  }
}
